import { createTheme } from "@mui/material/styles";
import { lightTheme, darkTheme } from "./ThemeColors";
import { BorderBottom, BorderRight, Height, Margin } from "@mui/icons-material";

const useStyles = (theme) => ({
  btn_primary: {
    // width: "100%",
    textAlign: "center",
    justifyContent: "center",
    textTransform: "capitalize",
    color: theme.palette.text.white,
    textWrap: "nowrap",
    // px: 2,
    boxShadow: 1,
    // padding: "4px 8px",
    background: theme.palette.primary.main,
  },

  btn_secondary: {
    // width: "100%",
    textAlign: "center",
    justifyContent: "center",
    textTransform: "capitalize",
    // color: theme.palette.text.white,
    textWrap: "nowrap",
    // px: 2,
    boxShadow: 1,
    // padding: "4px 8px",
    // background: theme.palette.primary.main,
  },

  btn_text: {
    // width: "100%",
    textAlign: "center",
    justifyContent: "center",
    textTransform: "capitalize",
    // color: theme.palette.text.white,
    textWrap: "nowrap",
    px: 2,
    // padding: "4px 8px",
    // background: theme.palette.primary.main,
  },

  ipt_helper_text: {
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
      fontWeight: "400",
    },
  },

  flex_direction_column: {
    display: "flex",
    flexDirection: "column",
  },

  btn_file_upload: {
    borderStyle: "dashed", // Make the outline dashed
    borderWidth: "1px", // Adjust the width if needed
    background: theme.palette.background.paper,
    color: theme.palette.greyscale.icons,
    textTransform: "capitalize",
    boxShadow: `0px 2px 4px rgba(0, 0, 0, 0.1)`,
    height: "100px",
    borderRadius: 1,

    px: 3,
    py: 1,
    borderColor: theme.palette.greyscale.stroke_1, // Use theme color or custom color
    "&:hover": {
      borderStyle: "dashed", // Maintain dashed style on hover
      borderColor: "primary.dark", // Change color on hover if needed
    },
  },

  VDG_colAction: {
    padding: 1,
    background: theme.palette.background.default,
    boxShadow: `0px 0px 2px 0px ${theme.palette.input_field.stroke}`,
    lineHeight: "27.24px",
    textAlign: "center",
    position: "sticky",
    right: 0,
    zIndex: theme.zIndex.appBar,
    minWidth: { xs: "40px", sm: "40px", md: "100px" },
    fontWeight: "bold",
    // display: { xs: "none", sm: "none", md: "flex" },
  },

  VDG_colActionBody: {
    background: theme.palette.background.default,
    p: 1,
    width: "100px",
    // position: "fixed",
    right: 0,
    zIndex: 1,
    textAlign: "center",
    position: "sticky",
    // background: theme.palette.background.fill,
  },

  VDG_colHead: {
    // background: theme.palette.background.fill,

    background: theme.palette.background.default,
    fontSize: theme.typography.subtitle_s,
    padding: 1,
    boxShadow: `0px 0px 2px 0px ${theme.palette.input_field.stroke}`,
  },

  VDG_colBody: {
    // background: theme.palette.background.fill,

    fontSize: theme.typography.body_s,
  },

  VDG_colActionIcon: {
    display: "flex",
    gap: 1,
    "& .MuiSvgIcon-root": {
      color: theme.palette.primary.main,
    },
    "& .menuItemText": {
      color: theme.palette.primary.main,
      fontSize: "16px",
    },
  },

  VDG_colActionIconMenu: {
    mt: 0,
    ml: 3,
  },

  VDG_tableContainer: {
    maxHeight: 440,
    minHeight: "60vh",
  },

  VDG_box: {
    overflow: "auto",
  },

  VDG_paper: {
    width: "100%",
    overflow: "hidden",
    // boxShadow: 10,
    boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)`,
  },

  breadcrumb: {},
  breadcrumb_tooltip: {},
  box_breadcrumb_view: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // alignContent: "flex-end",
    gap: 1,
    pb: 1,
    borderBottom: `1px solid ${theme.palette.greyscale.stroke_1}`,
  },

  box_breadcrumb: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    // alignContent: "flex-end",
    gap: 1,
    pb: 1,
    borderBottom: `1px solid ${theme.palette.greyscale.stroke_1}`,
  },

  btn_breadcrumb_back: {
    color: theme.palette.greyscale.icons,
    borderRadius: 1,
    // boxShadow: 1,
    background: theme.palette.background.default,
    // p: 2,
    padding: "2px",
    border: `1px solid ${theme.palette.greyscale.icons}`,
  },

  btn_breadcrumb_back_icon: {
    // color: "primary.main",
    // borderRadius: 1,
    // border: `1px solid ${theme.palette.primary.main}`,

    fontSize: theme.typography.button_l,
  },

  btn_breadcrumb_add: {
    color: theme.palette.text.white,
    borderRadius: 1,
    // boxShadow: 1,
    background: theme.palette.primary.main,
    // p: 2,
    padding: "4px",
    border: `1px solid ${theme.palette.primary.main}`,
  },

  btn_breadcrumb_add_icon: {
    // color: "primary.main",
    // borderRadius: 1,
    // border: `1px solid ${theme.palette.primary.main}`,

    fontSize: theme.typography.button_l,
  },

  VDG_pagination: {
    "& .MuiTablePagination-root": {
      fontSize: theme.typography.body_xs,
    },
    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
      fontSize: theme.typography.body_xs,
    },
    "& .MuiSelect-select": {
      fontSize: theme.typography.body_xs,
    },
    "& .MuiIconButton-root": {
      fontSize: theme.typography.body_xs,
    },
  },

  breadcrumb_link: {
    color: "text.secondary",
    fontSize: theme.typography.body_xxs,
  },
  breadcrumb_link_page: {
    color: "primary.main",
    fontSize: theme.typography.body_xxs,
  },

  breadcrumb_divider: {
    color: "text.secondary",
    fontSize: "20px",
  },

  box_page_container: {
    // boxShadow: 1,
    // background: theme.palette.background.paper,
    // p: 2,
    borderRadius: 1,
  },

  box_add_page_container: {
    // boxShadow: 1,
    // background: theme.palette.background.paper,
    // p: 2,
    borderRadius: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "80vh",
    // overflow: "auto",
  },

  appbar: {
    // marginTop: 2,
    my: 2,
    color: "none",
    background: "none",
    position: "static",
    minHeight: "42px",
    pb: 1,
    borderBottom: `1px solid ${theme.palette.greyscale.stroke_1}`,
    justifyContent: "center",
  },

  appbar_grid_container: { alignItems: "center" },

  appbar_title: {
    ...theme.typography.h5,
    color: theme.palette.text.primary,
    flexGrow: 1,
  },

  appbar_grid_add: { textAlign: { xs: "right", sm: "right" } },

  btn_appbar_add: {
    height: 40, // match height of Autocomplete input
    minHeight: 40,
    paddingLeft: 2,
    paddingRight: 2,
  },

  btn_add_cancel: {},

  btn_add_confirm: {},
  btn_appbar_search: {},

  appbar_grid_container_col_1: {},

  btn_appbar_search_icon: {
    borderRadius: "2px",
    // padding: "2px",
    color: theme.palette.greyscale.white,
    background: theme.palette.primary.main,
    transition: "color 0.3s ease, background-color 0.3s ease",
    "&:hover": {
      color: "primary.main", // color on hover
      backgroundColor: theme.palette.button.primaryBgHover, // subtle bg on hover
    },
    "&:active": {
      color: "primary.dark", // color on click/active
      backgroundColor: theme.palette.button.primaryBgActive, // stronger bg on click
    },
  },

  appbar_grid_search: {
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
  },

  ipt_appbar_search_auto: {
    flexGrow: 1,
    // Make height consistent with button
    "& .MuiInputBase-root": {
      height: 40, // or match button height
      minHeight: 40,
    },
    "& .css-10ryhb3-MuiAutocomplete-root": {
      paddingTop: "5px",
    },
  },

  ipt_appbar_search: {
    "& .MuiInputBase-root": {
      height: 40,
      minHeight: 40,
    },
    padding: "0px",
    "& .css-yezi2-MuiInputBase-root-MuiOutlinedInput-root": {
      paddingRight: "1px",
      paddingTop: "2px",
    },

    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
      paddingTop: "5px",
      paddingBottom: "5px",
      paddingRight: "1px",
    },
  },

  add_form_page_container: { flex: 1 },

  add_form_page_grid_container: {},

  add_form_page_button_box: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    py: 2,
    borderTop: `1px solid ${theme.palette.divider}`,
  },

  header: {
    zIndex: (theme) => theme.zIndex.drawer + 1,
    transition: "width 0.3s",
    background: theme.palette.background.paper,
    boxShadow: "1px 1px 1px rgba(0, 0, 0, 0.1)",
  },

  headerImage: {
    background: "#000",
  },

  m_headerHamburgerIcon: {
    mr: 2,
    color: theme.palette.text.primary,
    display: { sm: "none" },
  },

  headerHamburgerIcon: {
    color: theme.palette.text.primary,
    // mr: 2,
    // display: { xs: "none", sm: "block" },
    // px: 1,
  },

  headerTitle: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.h6,
  },

  headerNotificationMenu: {
    mt: 1,
    paddingTop: "0px",
  },

  boxHeaderProfile: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: 1,
  },

  headerProfileUserName: {
    ml: 2,
    color: theme.palette.text.primary,
    fontSize: theme.typography.body_s,
  },

  headerProfileMenu: {
    mt: 1,
    // boxShadow: 10,
    background: "transparent",
    color: "none",
  },

  view_data_grid_page: {},
  view_page_container: {},
  grn_view_page_container: { pt: 2 },
  grn_popup_page_container: {},

  // GRN Styles Start
  title_container: { my: 2 },

  title_text: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.h5,
  },

  grn_supplier_container: {
    // p: 2,
    // boxShadow: 1,
    // boxShadow: `1px 0px 1px rgba(0, 0, 0, 0.1)`,
    // borderRadius: 1,
    // my: 2,
    // background: theme.palette.background.paper,
  },
  grn_search_container: {
    // p: 2,
    // boxShadow: 1,
    // borderRadius: 1,

    // boxShadow: `1px 0px 1px rgba(0, 0, 0, 0.1)`,
    my: 2,
    // background: theme.palette.background.paper,
  },

  grn_sub_title_text: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_m,
    // background: theme.palette.background.paper,
  },

  btn_advanced_search: {
    borderRadius: 1,
    boxShadow: 2,
  },

  filter_container: {
    // padding: "16px",
    width: "100%",
    borderRadius: "8px",
    // my: 2,
  },

  common_Cell_Style: {
    minWidth: "140px",
    maxWidth: "180px",
    // width: "180px",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    textOverflow: "ellipsis",
  },

  common_cell_style_2: {
    // minWidth: "240px",
    minWidth: {
      xs: "160px",
      sm: "180px",
      md: "180px",
      lg: "240px",
      xl: "240px",
    },

    maxWidth: "30px",
    flex: 1,
    // width: "180px",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "flex-start",
    alignContent: "center",
    // p: 0,

    px: 2,
    py: 1,
  },

  common_cell_style_3: {
    // minWidth: "140px",
    minWidth: {
      xs: "160px",
      sm: "180px",
      md: "180px",
      lg: "240px",
      xl: "240px",
    },

    maxWidth: "30px",
    flex: 1,
    // width: "180px",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    // p: 0,

    px: 2,
    py: 2,
  },

  rvw_common_cell_style: {
    // minWidth: "240px",
    minWidth: {
      xs: "160px",
      sm: "180px",
      md: "180px",
      lg: "180px",
      xl: "240px",
    },

    maxWidth: "30px",
    flex: 1,
    // width: "180px",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    // p: 0,
    px: 2,
    py: 1,
  },

  common_cell_style_2_search: {
    // minWidth: "240px",
    minWidth: {
      xs: "160px",
      sm: "180px",
      md: "180px",
      lg: "240px",
      xl: "240px",
    },

    maxWidth: "30px",
    flex: 1,
    // width: "180px",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "center",
    alignContent: "center",
    // p: 0,
    px: 2,
    py: 1,
  },

  grn_table_header_col: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_m,
    // borderRight: `1px solid ${theme.palette.divider}`,
    py: 1,
    p: 0,
  },
    grn_table_header_col_view: {
     py: 1.5,
                        px: 1.5,
                        fontWeight: 600,
                        fontSize: "0.7rem",
                        letterSpacing: "0.07em",
                       
                        color: theme.palette.text.secondary,
                        whiteSpace: "nowrap",
                       
                        borderBottom: `1px solid ${theme.palette.divider}`,
  },

  grn_table_header_col_box: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    // pb: 1,
    borderRight: `1px solid ${theme.palette.divider}`,
    mx: 2,
    my: 1,
  },

  grn_table_header_col_2: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_m,
    // borderRight: `1px solid ${theme.palette.divider}`,
    py: 1,
    p: 0,
  },

  grn_table_header_col_box_2: {
    display: "flex",
    // alignItems: "flex-start",
    // flexDirection: "column",
    // justifyContent: "center",
    justifyContent: "flex-start",

    // pb: 1,
    textAlign: "left",
    // textAlign: "center",

    borderRight: `1px solid ${theme.palette.divider}`,
    // mx: 2,
    my: 1,
    ml: 2,
  },

  grn_table_body_col_box: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    pr: 2,
    gap: 0, //this must remove if we do not use this layout
    // pb: 1,
    // borderRight: `1px solid ${theme.palette.divider}`,
  },

  grn_table_body_col_box_2: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    // pr: 2,
    gap: 0, //this must remove if we do not use this layout
    // pb: 1,
    // borderRight: `1px solid ${theme.palette.divider}`,
  },

  rtn_table_body_col_box: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    // pr: 2,
    gap: 0, //this must remove if we do not use this layout
    // pb: 1,
    // borderRight: `1px solid ${theme.palette.divider}`,
  },

  grn_table_row: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_s,

    // py: 1,
  },



  grn_table_row_title: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body_xs,
  },

  btn_grn_search: {
    textAlign: "center",
    justifyContent: "center",
    textTransform: "capitalize",
    color: theme.palette.greyscale.white,
    px: 2,
    boxShadow: 1,
    background: theme.palette.primary.main,
    borderRadius: 1,
    transition: "background-color 0.3s, color 0.3s",
    // width: "100%",

    // Hover effect
    "&:hover": {
      background: theme.palette.secondary.main, // Change to your desired hover color
      color: theme.palette.greyscale.white, // Change text color on hover
    },

    // Click (active) effect
    "&:active": {
      background: theme.palette.primary.dark, // Change to your desired click color
      boxShadow: "none",
    },
  },

  grn_supplier_title: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body_s,
  },
  grn_supplier_text: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.subtitle_xs,
    textTransform: "uppercase",
  },

  grn_bill_name: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_s,
  },
  grn_bill_name_title: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_s,
  },
  grn_bill_price: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.subtitle_m,
  },

  grn_bill_content: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    // borderBottom: "1px dotted black",
  },

  search_result: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: 1,
    borderColor: theme.palette.greyscale.stroke_1,
  },
  search_result_text: {
    width: "100%",
  },

  advance_search_container: {
    p: 2,
    borderRadius: 1,
    backgroundColor: theme.palette.background.paper,
    // boxShadow: 1,
    boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)`,
  },

  grn_action_items_box: {
    display: "flex",
    gap: 1,
  },


  grn_action_items_box1: {
    display: "flex",

  },
  grn_cell_collapse_box: {
    // p: 1,
    pt: 2,
    gap: 2,
    // pr: 2,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${theme.palette.greyscale.divider_1}`,
    maxWidth: "320px",
    pb: 1,
    // flex: 1,

    // backgroundColor: theme.palette.background.paper,
    // borderRadius: 1,
    // boxShadow: 1,
    // boxShadow: `0px 1px 1px rgba(0, 0, 0, 0.1)`,
  },

  rtn_cell_collapse_box: {
    // p: 1,
    pt: 1,
    gap: 2,
    mt: 1,
    // pr: 2,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${theme.palette.greyscale.divider_1}`,
    // maxWidth: "320px",
    // pb: 1,
    // flex: 1,

    // backgroundColor: theme.palette.background.paper,
    // borderRadius: 1,
    // boxShadow: 1,
    // boxShadow: `0px 1px 1px rgba(0, 0, 0, 0.1)`,
  },

  vd_cell_collapse_box: {
    // p: 1,
    pt: 1,
    // gap: 2,
    pr: 2,
    display: "flex",
    flexDirection: "column",
    // borderTop: `1px solid ${theme.palette.greyscale.divider_1}`,
    maxWidth: "320px",
    // pb: 1,
    // flex: 1,

    // backgroundColor: theme.palette.background.paper,
    // borderRadius: 1,
    // boxShadow: 1,
    // boxShadow: `0px 1px 1px rgba(0, 0, 0, 0.1)`,
  },

  grn_table_body_col_box_row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },

  grn_table_row_title_name: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body_xs,
  },

  grn_table_row_title_value: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_xs,
  },

  common_cell_style_2_action: {
    // background: "#ffff00",
    maxWidth: "80px",
    // padding: 0,
    // display: "flex",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    // px: 2,
    py: 1,
  },

  common_cell_style_2_action_box: {
    display: "flex",
    alignItems: "flex-start",
  },

  grn_table_expand_cell: {
    borderBottom: 0,
    padding: 0,
    backgroundColor: theme.palette.background.bgShade_2,
  },
  rg_table_expand_cell: {
    borderBottom: 0,
    padding: 0,
    backgroundColor: theme.palette.background.default,
  },

  grn_table_expand_cell_container: {
    m: 1,
    py: 0,
    pl: 4,
  },
  rg_table_expand_cell_container: {
    m: 1,
    py: 0,
    pl: 0,
  },

  grn_table_expand_cell_container_title: {
    ml: 2,

  },
  grn_table_expand_cell_grid: {
    mt: 0,
    ml: 2,
  },

   grn_table_expand_cell_grid1: {
    mt: 0,
    
  },

  grn_table_expand_cell_action: {
    display: "flex",
    justifyContent: "flex-end",
  },

  grn_table_expand_cell_container_action: {
    p: 1,
    m: 1,
  },

  grn_table_row_expand: {
    // background: "#ffff00",
    maxWidth: "32px",
    // display: "flex",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    px: 2,
    py: 1,
  },

  grn_table_row_expand_container: {
    // padding: 0,
    // px: 2,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
  },

  grn_table_header_col_action: {
    maxWidth: "80px",
  },
  grn_table_header_col_first: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_m,
    maxWidth: "32px",
    padding: 0,
  },
  grn_table_header_row: {
    background: theme.palette.background.bgShade_1,
    boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)`,
  },

  grn_table_container: {
    boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)`,
    padding: 1,
    mt: 2,
  },

  box_space_between: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    
  },

  box_left_align: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between",
  },
  box_center_align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  box_right_align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },

  grn_supplier_det_grid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    alignContent: "center",
    gap: 1,
    borderRight: `1px solid ${theme.palette.greyscale.stroke_1}`,
  },
  supplier_icons: {
    color: theme.palette.greyscale.icons,
  },
  txt_field_standard: {
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInputBase-root": {
      outline: "none !important",
      boxShadow: "none !important",
    },
    "& input": {
      outline: "none !important",
    },
  },

  grn_right_according: {
    background: theme.palette.background.bgShade_1,
    boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)`,
  },
  grn_right_according_details: {
    background: theme.palette.background.paper,
    // boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)`,
  },

  txt_grn_input: {
    maxWidth: "80px",
    backgroundColor: "transparent",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: theme.palette.input_field.fill,
        "& .MuiOutlinedInput-notchedOutline": {
          // border: theme.palette.input_field.stroke,
          border: `1px solid ${theme.palette.input_field.stroke}`,
        },
      },
      "&.Mui-focused": {
        // backgroundColor: "#e0f7e9",
        backgroundColor: theme.palette.input_field.fill,

        "& .MuiOutlinedInput-notchedOutline": {
          // border: "1px solid #4caf50",
          border: `1px solid ${theme.palette.input_field.stroke}`,
        },
      },
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "right",
      padding: "2px",
      backgroundColor: "transparent",
      fontSize: theme.typography.subtitle_s,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none", // no border by default
    },
  },

  txt_grn_input_2: {
    // maxWidth: "80px",
    backgroundColor: "transparent",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "transparent",
      py: 1,

      "&:hover": {
        // backgroundColor: theme.palette.input_field.fill,
        "& .MuiOutlinedInput-notchedOutline": {
          // border: theme.palette.input_field.stroke,
          // border: `1px solid ${theme.palette.input_field.stroke}`,
        },
      },
      "&.Mui-focused": {
        // backgroundColor: "#e0f7e9",
        backgroundColor: theme.palette.input_field.fill,

        "& .MuiOutlinedInput-notchedOutline": {
          // border: "1px solid #4caf50",
          border: `1px solid ${theme.palette.input_field.stroke}`,
        },
      },
    },
    "& .MuiOutlinedInput-input": {
      // textAlign: "right",
      padding: "2px",
      // backgroundColor: "transparent",
      fontSize: theme.typography.subtitle_s,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      // no border by default
    },
  },

  txt_grn_input_3: {
    // maxWidth: "80px",
    backgroundColor: "transparent",
    "& .MuiOutlinedInput-root": {
      // backgroundColor: "transparent",
      py: 1,
      px: 2,
      backgroundColor: theme.palette.input_field.fill,

      "&:hover": {
        backgroundColor: theme.palette.input_field.fill,
        "& .MuiOutlinedInput-notchedOutline": {
          // border: theme.palette.input_field.stroke,
          border: `1px solid ${theme.palette.input_field.stroke}`,
        },
      },
      "&.Mui-focused": {
        // backgroundColor: "#e0f7e9",
        backgroundColor: theme.palette.input_field.fill,

        "& .MuiOutlinedInput-notchedOutline": {
          // border: "1px solid #4caf50",
          border: `1px solid ${theme.palette.input_field.stroke}`,
        },
      },
    },
    "& .MuiOutlinedInput-input": {
      // textAlign: "right",
      padding: "2px",
      backgroundColor: "transparent",
      fontSize: theme.typography.subtitle_s,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      // no border by default
    },
  },

  ipt_file_attach: {
    color: theme.palette.text.primary,
    flex: 1,
    minWidth: 0,
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 0,
      color: theme.palette.text.primary,
      width: "100%",
      "& fieldset": {
        border: "none",
        color: theme.palette.text.primary,
      },
    },
    "& .MuiInputBase-input": {
      width: "100%",
      minWidth: "100px",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: theme.palette.text.primary,
      color: theme.palette.text.primary,
    },
  },

  vg_grid_new_button: {
    display: "flex",
    justifyContent: "flex-end",
  },

  vg_appbar: {
    // my: 2,
    pt: 1,
    color: "none",
    background: "none",
    position: "static",
    minHeight: "42px",
    pb: 1,
    borderBottom: `1px solid ${theme.palette.greyscale.stroke_1}`,
    justifyContent: "center",
  },

  vg_search_appbar: {
    // my: 2,
    pt: 1,
    color: "none",
    background: "none",
    position: "static",
    minHeight: "42px",
    pb: 1,
    // borderBottom: `1px solid ${theme.palette.greyscale.stroke_1}`,
    justifyContent: "center",
  },

  // sx={{
  //   maxWidth: "80px",
  //   "& .MuiInput-underline:before": {
  //     borderBottom: "none",
  //   },
  //   "& .MuiInput-underline:after": {
  //     borderBottom: "none",
  //   },
  //   "& .MuiInput-underline:hover:not(.Mui-disabled):before":
  //     {
  //       borderBottom: "none",
  //     },
  // }}

grn_right_sidebar_box: {
  position: "fixed",
  top: 64,
  width: { xs: "80vw", sm: 400 },
  bgcolor: "background.paper",
  boxShadow: 3,
  minHeight: 650,
  height: "100%",
  p: 1,
  zIndex: 99999,
  transition: "right 0.3s ease-in-out",
  pointerEvents: "auto",
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  paddingRight: "12px", // space for scrollbar

  scrollbarWidth: "thin", // Firefox
  scrollbarGutter: "stable", //  keeps scrollbar outside layout shift
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent", // blends with background
    marginRight: "-4px", //  moves scrollbar visually outside
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d15353ff",
    borderRadius: "4px",
  },
},

  // GRN Styles End

  // login styles start
  login_container: {
    position: "relative",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f0e6ef",
    overflow: "hidden",
    backgroundColor: "#8EC5FC",
    backgroundImage:
      "linear-gradient(62deg,rgb(200, 234, 250) 0%, #0F61AC 100%)",
  },

  shape1: {
    position: "absolute",
    top: "5%",
    left: "10%",
    width: "300px",
    height: "300px",
    background: "rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    animation: "move 10s infinite",
    "@keyframes move": {
      "0%": { transform: "translate(0, 0)" },
      "50%": { transform: "translate(100px, 100px)" },
      "100%": { transform: "translate(0, 0)" },
    },
  },

  img_lg_card_shape1: {
    width: "40%", // You can adjust the size as needed
    height: "40%", // You can adjust the size as needed
    objectFit: "cover", // Ensures the image covers the area while maintaining aspect ratio
    borderRadius: 2, // Optional: applies border radius if desired
    position: "absolute", // You can use absolute positioning for the image inside the container
    top: "50%", // Moves the image to the vertical center
    left: "50%", // Moves the image to the horizontal center
    transform: "translate(-50%, -50%)", // Offsets the image to perfectly center it
    display: "flex",
    justifyContent: "center", // Ensures the content is horizontally centered
    alignItems: "center", // Ensures the content is vertically centered
  },

  shape2: {
    position: "absolute",
    top: "60%",
    right: "15%",
    width: "200px",
    height: "200px",
    background: "rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    animation: "move 15s infinite",
    "@keyframes move": {
      "0%": { transform: "translate(0, 0)" },
      "50%": { transform: "translate(-50px, -50px)" },
      "100%": { transform: "translate(0, 0)" },
    },
  },

  login_card_container: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: "0",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    maxWidth: "900px",
    margin: "auto",
    zIndex: 1,
    display: "flex",
    overflow: "hidden",
    // "@media (max-width: 600px)": {
    //     backgroundColor: "#8EC5FC",
    // backgroundImage: "linear-gradient(62deg, #8EC5FC 0%, #0077B6 100%)",
    // },
  },

  login_retro_text: {
    // fontFamily: "'Pacifico', cursive",
    color: "#fff",
    fontSize: "10px",
  },
  login_card_left: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#e6f0ff",
    // borderTopLeftRadius: "15px",
    // borderBottomLeftRadius: "15px",
    padding: "20px",
    overflow: "hidden",
  },
  login_card_right: {
    padding: "40px",
  },
  retro_text: {
    // fontFamily: "'Pacifico', cursive",
    color: "#1F1D2B",
  },

  login_btn: {
    // textTransform: "capitalize",
    // backgroundColor: "#1E90FF",
    // color: "#fff",
    // "&:hover": {
    //   backgroundColor: "#1C86EE",
    // },
    // transition: "background-color 0.3s ease, transform 0.3s ease",
    // "&:hover": {
    //   backgroundColor: "#1C86EE",
    //   transform: "scale(1.05)",
    // },
    width: "35%",
    position: "relative",
    margin: 0,
    padding: "0.4em 1em",
    outline: "none",
    textDecoration: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    border: "none",
    textTransform: "capitalize",
    backgroundColor: theme.palette.background.primary,
    borderRadius: 1,
    color: "#fff",
    fontWeight: 300,
    fontSize: "16px",
    zIndex: 0,
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.02, 0.01, 0.47, 1)",
    "&:hover": {
      animation: "sh0 0.5s ease-in-out both",
      "&::before, &::after": {
        opacity: 0.15,
        transform: "translate(50%, 0) scale(1.1)",
      },
    },
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      right: 0,
      bottom: 0,
      width: "100px",
      height: "100px",
      borderRadius: "50%",
      background: "#fff",
      opacity: 0,
      zIndex: -1,
      transform: "translate(100%, -25%) translate3d(0, 0, 0)",
      transition:
        "transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1)",
    },
  },
  // login styles end

  // supplier Start
  box_ipt_file: {
    overflow: "hidden",
    borderRadius: 1,
    // borderColor: theme.palette.input_field.fill,
    // border: 1,
    border: `1px solid ${theme.palette.input_field.stroke}`,

    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
    "& > button": {
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    "& > .MuiTextField-root": {
      flex: 1,
      minWidth: 0,
    },
  },
  supplier_sub_title_text: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.subtitle_s,
    // background: theme.palette.background.paper,
  },

  supplier_page_button_box: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    pt: 2,
    borderTop: `1px solid ${theme.palette.divider}`,
    bottom: 0,
  },

  db_card: {
    flexDirection: "column",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    boxShadow: 2,
    // borderRadius: theme.shape.borderRadius,
    textAlign: "center",
    backgroundColor: "background.paper",
    margin: "auto",
    // maxWidth: {
    //   xs: "100%",   // Full width on extra small screens
    //   sm: 350,      // Small screens
    //   md: 400,      // Medium screens
    //   lg: 450,      // Large screens
    //   xl: 600,      // Extra large screens
    // },
    // minWidth: {
    //   xs: "100%",
    //   sm: 250,
    //   md: 300,
    //   lg: 580,
    //   xl: 700,
    // },
    maxHeight: {
      xs: 350,
      sm: 350,
      md: 350,
      lg: 350,
      xl: 350,
    },
    minHeight: {
      xs: 220,
      sm: 250,
      md: 250,
      lg: 250,
      xl: 250,
    },
    overflowY: "auto",
    scrollbarWidth: "thin", // For Firefox
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#ccc",
      borderRadius: "4px",
    },
  },
  // supplier end

  // EditGrn
  edgrn_save_btn_box: {
    gap: 1,
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
    mb: 2,
    width: "100%",
    //   pb: 6,
  },

  grn_action_container: {
    position: "fixed",
    py: 1,
    px: 2,
    zIndex: 10,
    top: "auto",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.input_field.fill,
   borderTop: `1px solid ${theme.palette.greyscale?.stroke_1}`,
  },

  edgrn_right_sidebar: {
    position: "fixed",
    top: 64,
    width: { xs: "80vw", sm: 320 },
    height: "100vh",
    bgcolor: "background.paper",
    boxShadow: 3,
    p: 1,
    zIndex: 1,
    // zIndex: (theme) => theme.zIndex.drawer + 10,
    transition: "right 0.3s ease-in-out",
    pointerEvents: "auto", // sidebar accepts pointer events
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    scrollbarWidth: "none", // Hide scrollbar in Firefox
    "&::-webkit-scrollbar": {
      display: "none", // Hide scrollbar in WebKit browsers
    },
  },
  // EditGrn end

  // PDF documents
  sup_buy_container: {
    display: "flex",
    justifyContent: "space-between",
    mb: 2,
  },

  sup_buy_container_inside: {
    display: "flex-end",
    flexDirection: "column",
    color: "black",
    width: "50%",

    // justifyContent: "space-between",
    // mb: 2,
  },
  cellSx : { fontSize: 13, py: 1.25, px: 1.5, whiteSpace: 'nowrap', color: 'text.primary' }
});

export { lightTheme, darkTheme, useStyles };
